import { handleActions } from "redux-actions";
import actionCreators from "../../actions/top/index_of_signed_in";

const initialState = {
  isWebViewTabApp: false,
  circles: [],
  newArrivalCircles: [],
  events: [],
  blogs: [],
  reports: [],
  currentUser: {},
  serviceId: 1,
  userAgent: "pc",
};

export default handleActions(
  {
    [actionCreators.top.indexOfSignedIn.set]: (state, action) =>
      Object.assign({}, state, action.payload),
  },
  initialState
);
